import { useFieldArray, useFormContext } from "react-hook-form";
import { useDialog } from "../../../../Upsell/modernTS/JUI/Dialogs";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import { IconButton, Stack, TableCell, TableFooter, TablePagination, TableRow, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import _ from "lodash";
import { utils, writeFile } from "xlsx";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import { Delete } from "@mui/icons-material";
import { IdRow } from "./Eds";
import UploadExcel from "./UploadExcel";

export default function ApiIdMapping() {
  const { control } = useFormContext<{ eds_connection__composed_id_mapping: IdRow[] }>();
  const { createDialog } = useDialog();
  const [newRow, setNewRow] = useState<IdRow>({ composed_id: "", article_id: "", option_id: "" });
  const { fields, insert, update, remove, append } = useFieldArray<{ eds_connection__composed_id_mapping: IdRow[] }>({
    control,
    name: "eds_connection__composed_id_mapping",
    id: "key",
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      <Stack direction={"row"} gap={5}>
        <Button
          onClick={() => {
            createDialog({
              name: "upload-excel",
              fullWidth: true,
              maxWidth: "xl",
              children: (
                <UploadExcel
                  columns={[
                    { value: "composed_id", label: "Composed id" },
                    { value: "article_id", label: "Article id" },
                    { value: "option_id", label: "Option id" },
                  ]}
                  onDataAccept={(data) => {
                    remove();
                    data = _.uniqBy(data, JSON.stringify);
                    insert(
                      0,
                      data.map((row) => ({
                        composed_id: row[0] ?? "",
                        article_id: row[1] ?? "",
                        option_id: row[2] ?? "",
                      }))
                    );
                  }}
                />
              ),
            });
          }}
          variant={"contained"}
        >
          Upload excel
        </Button>
        <Button
          onClick={() => {
            const workbook = utils.book_new();
            const worksheet = utils.json_to_sheet(
              fields.map((row) => {
                delete row.id;
                return { composed_id: row.composed_id, article_id: row.article_id, option_id: row.option_id };
              })
            );

            utils.book_append_sheet(workbook, worksheet, "Data");

            writeFile(workbook, "Eds-" + new Date().toISOString() + ".xlsx", { compression: true });
          }}
          variant={"outlined"}
        >
          Download excel
        </Button>
      </Stack>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Composed id</TableCell>
            <TableCell>Article Id</TableCell>
            <TableCell>Option Id</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((field, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  onChange={(e) => {
                    update(index, { ...field, composed_id: e.target.value });
                  }}
                  value={field.composed_id}
                />
              </TableCell>
              <TableCell>
                <TextField
                  onChange={(e) => {
                    update(index, { ...field, article_id: e.target.value });
                  }}
                  value={field.article_id}
                />
              </TableCell>
              <TableCell>
                <TextField
                  onChange={(e) => {
                    update(index, { ...field, option_id: e.target.value });
                  }}
                  value={field.option_id}
                />
              </TableCell>
              <TableCell>
                <IconButton
                  onClick={() => {
                    remove(index);
                  }}
                >
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={3}
              count={fields.length}
              onPageChange={handleChangePage}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              slotProps={{
                select: {
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                },
              }}
              onRowsPerPageChange={handleChangeRowsPerPage}
              // ActionsComponent={TablePaginationActions}
            />
          </TableRow>
          <TableRow>
            <TableCell>Add new row</TableCell>
            <TableCell />
            <TableCell>
              <Button
                disabled={
                  newRow.composed_id.length === 0 || newRow.article_id.length === 0 || newRow.option_id.length === 0
                }
                onClick={() => {
                  append(newRow);
                  setNewRow({ composed_id: "", article_id: "", option_id: "" });
                }}
                variant={"contained"}
              >
                Add
              </Button>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <TextField
                onChange={(e) => {
                  setNewRow({ ...newRow, composed_id: e.target.value });
                }}
                value={newRow.composed_id}
              />
            </TableCell>
            <TableCell>
              <TextField
                onChange={(e) => {
                  setNewRow({ ...newRow, article_id: e.target.value });
                }}
                value={newRow.article_id}
              />
            </TableCell>
            <TableCell>
              <TextField
                onChange={(e) => {
                  setNewRow({ ...newRow, option_id: e.target.value });
                }}
                value={newRow.option_id}
              />
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </Box>
  );
}
